module.exports = __webpack_public_path__ + "images/puzzle/Skeleton/PNG/Piece05.b01ac6917eee83a1c2e74dea0464bea5.png";